<template>
  <div class="mail" v-loading="loading">
    <c-tab :tabs="tabs"></c-tab>
  </div>
</template>
<script>
import CTab from '@/components/common/tab'
import * as types from '@/store/mutation-types'

export default {
  components: { CTab },
  data () {
    return {
      loading: false,
      tabs: [ {
        label: '上传文件',
        component: () => import('./#upload')
      }, {
        label: '我的任务',
        component: () => import('./#list')
      }]
    }
  },
  watch: {
    $route: {
      handler: function() {
        const crumbs = {
          path: this.$route.path,
          tabs: this.tabs
        }
        this.$store.commit(types.RECORD_GLOBAL_CRUMBSECOND, crumbs)
      },
      immediate: true
    }
  },
  created() {
    this.loading = true
    this.$http.post(`/once/previllage`, { 'a': 1 }).then(res => {
      // res.data.previllage = 1
      if (res.data.previllage === 1) {
        this.tabs.splice(0, 1)
      }
    }).finally(() => {
      this.loading = false
    })
  }
}
</script>
<style lang="scss" scoped>

</style>
